import request from '@/api/utils';

export function getStringboxList(formdata = {}, method = 'post') {
  const url = '/panel/stringbox/list';
  return request.Api(url, formdata, method);
}
 
export function stringboxMinute(formdata = {}, method = 'post') {
  const url = '/panel/stringbox/minutecomparison';
  return request.Api(url, formdata, method);
}


export function stringboxHourly(formdata = {}, method = 'post') {
  const url = '/panel/stringbox/hourcomparison';
  return request.Api(url, formdata, method);
}


export function stringboxDaily(formdata = {}, method = 'post') {
  const url = '/panel/stringbox/daily';
  return request.Api(url, formdata, method);
}

export function stringboxMonthly(formdata = {}, method = 'post') {
  const url = '/panel/stringbox/monthly';
  return request.Api(url, formdata, method);
}

export function stringboxYearly(formdata = {}, method = 'post') {
  const url = '/panel/stringbox/yearly';
  return request.Api(url, formdata, method);
}